const styles = {
  root: {
    background: '#FDFDFD',
    height: '100vh',
    paddingBottom: 100,
    boxSizing: 'border-box',
    '& .floating-action': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 16,
      paddingTop: 8,
    },
    '& .benefit-card': {
      // background: '#F5F6F8',
      padding: 12,
      borderRadius: 8,
    },
  },
};

export default styles;
